﻿import { Controller } from "@hotwired/stimulus";
import "toastr";

export default class extends Controller {
    static get values() {
        return {
            copiedLinkToClipboardText: String
        }
    }

    static get targets() {
        return ["shareMenuItem"];
    }

    connect() {
        if (navigator.canShare) {
            this.shareMenuItemTarget.classList.remove("d-none");
        }
    }

    async copyLink(e) {
        e.preventDefault();
        await navigator.clipboard.writeText(e.target.href);
        toastr.success(this.copiedLinkToClipboardTextValue);
    }

    async shareLink(e) {
        e.preventDefault();
        await navigator.share({ url: e.target.href });
    }
}